import React, { useState, useEffect } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
} from "reactstrap"
import Select from "react-select"
import { post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"
import Loader from "common/loader"
import { ARTICLES_SEARCH, LANGUAGES_SEARCH } from "helpers/api_endpoints"
import moment from "moment"
//meta title
document.title = "Articles"

function ArticlesList() {
  const navigate = useNavigate()
  const location = useLocation()
  const [name, setName] = useState("")
  const [id, setId] = useState("")
  const [image, setImage] = useState("")
  const [statuses, setStatuses] = useState([
    {
      value: "",
      label: "All",
    },
    {
      value: "1",
      label: "Active",
    },
    {
      value: "0",
      label: "Non Active",
    },
  ])
  const [loading, setLoading] = useState(true)
  const [articles, setArticles] = useState([])
  const [languages, setLanguages] = useState([])
  const [filters, setFilters] = useState({})
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [successMsg, setsuccessMsg] = useState("")

  useEffect(() => {
    const getArticles = async () => {
      try {
        setLoading(true)
        const response = await post(
          `${ARTICLES_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`,
          filters
        )
        const data = response.data
        setArticles(data.data)
        setTotalPages(data.pagination.totalPages)
      } catch (error) {
        console.error("Error fetching articles:", error)
      } finally {
        setLoading(false)
      }
    }

    const getLanguages = async () => {
      try {
        const response = await post(LANGUAGES_SEARCH)
        setLanguages(response.data)
      } catch (error) {
        console.error("Error fetching languages:", error)
      }
    }

    getLanguages()
    getArticles()
  }, [page, filters])

  const successMessage = () => {
    if (location.state) {
      setsuccessMsg(location.state.successMsg)
      setTimeout(() => {
        location.state.successMessage = ""
        setsuccessMsg("")
      }, 4000)
    }
  }

  const handleFilter = (type, value) => {
    const filtvalues = { ...filters }
    if (value === "") {
      delete filtvalues[type]
    } else {
      switch (type) {
        case "id":
          setId(value)
          filtvalues.id = value
          break
        case "name":
          setName(value)
          filtvalues.name = value
          break
        case "status":
          filtvalues.status = value
          break
        case "fromDate":
          filtvalues.fromDate = value
          if (value && !filtvalues.toDate) {
            const today = new Date().toISOString().split("T")[0]
            filtvalues.toDate = today
          }
          break
        case "toDate":
          filtvalues.toDate = value
          if (value && !filtvalues.fromDate) {
            const thirtyDaysAgo = new Date()
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
            filtvalues.fromDate = thirtyDaysAgo.toISOString().split("T")[0]
          }
          break
        default:
          break
      }
    }
    setFilters(filtvalues)
    setPage(1)
  }
  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Articles" />
          <Row>
            <Col xl={12}>
              <Card>
                <br></br>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                <CardTitle>
                  <Link to="/articles/add">
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create</Trans>
                    </button>
                  </Link>
                </CardTitle>

                <div style={{ margin: "25px" }}>
                  <div className="row">
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>ID</Trans>
                      </Label>
                      <Input
                        name="id"
                        className="form-control"
                        placeholder=""
                        type="number"
                        onChange={e => handleFilter("id", e.target.value)}
                        onKeyDown={e => handleFilter("id", e.target.value)}
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Name</Trans>
                      </Label>
                      <Input
                        name="name"
                        className="form-control"
                        placeholder=""
                        type="text"
                        onChange={e => handleFilter("name", e.target.value)}
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>From Date</Trans>
                      </Label>
                      <Input
                        name="fromDate"
                        className="form-control"
                        placeholder=""
                        type="date"
                        onChange={e => handleFilter("fromDate", e.target.value)}
                        onKeyDown={e =>
                          handleFilter("fromDate", e.target.value)
                        }
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>To Date</Trans>
                      </Label>
                      <Input
                        name="toDate"
                        className="form-control"
                        placeholder=""
                        type="date"
                        onChange={e => handleFilter("toDate", e.target.value)}
                        onKeyDown={e => handleFilter("toDate", e.target.value)}
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Status</Trans>
                      </Label>
                      <Select
                        name="status"
                        className="form-control"
                        placeholder="Select Status"
                        options={statuses.map(item => ({
                          value: item.value,
                          label: item.label,
                        }))}
                        onChange={selectedOption =>
                          handleFilter(
                            "status",
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        isClearable
                      />
                    </div>
                  </div>
                </div>

                <CardBody>
                  <div className="table-responsive">
                    <Table className="table table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>
                            <Trans>ID</Trans>
                          </th>
                          <th>
                            <Trans>Article Title</Trans>
                          </th>
                          <th>
                            <Trans>Creation Date</Trans>
                          </th>
                          <th>
                            <Trans>Status</Trans>
                          </th>
                          <th>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <th colSpan={6} className="text-center">
                              <Loader></Loader>
                            </th>
                          </tr>
                        ) : null}
                        {articles.map((article, index) => (
                          <tr key={index}>
                            <td>{article.id}</td>
                            <td>
                              <td>
                                {article.named && article.named.title
                                  ? article.named.title.map((c, i) => (
                                      <p key={i}>{Object.values(c)}</p>
                                    ))
                                  : article.name}
                              </td>
                            </td>
                            <td>
                              {moment(article.createdAt).format("YYYY-MM-DD")}
                            </td>
                            <td>
                              {article.status == 1 ? (
                                <Badge className="bg-success">
                                  <Trans>Active</Trans>
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  <Trans>Non Active</Trans>
                                </Badge>
                              )}
                            </td>
                            <td>
                              <Link to={`/articles/edit/${article.id}`}>
                                <button className="btn btn-sm btn-info">
                                  <i className="dripicons-pencil"></i> &nbsp;
                                  <Trans>Edit</Trans>
                                </button>
                              </Link>{" "}
                              &nbsp;
                              <Link to={`/articles/remove/${article.id}`}>
                                <button className="btn btn-sm btn-danger">
                                  <i className="dripicons-trash"></i> &nbsp;
                                  <Trans>Remove</Trans>{" "}
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <br></br>
                  <div className="text-center">
                    {/* Pagination controls */}
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handlePrevPage}
                      disabled={page === 1}
                    >
                      <Trans>Previous</Trans>
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handleNextPage}
                      disabled={page === totalPages}
                    >
                      <Trans>Next</Trans>
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ArticlesList
